/**
 * @typedef {
 *   PENDENTE_DE_ESCLARECIMENTO |
 *   EM_ANALISE |
 *   RISCO_DETECTADO |
 *   INEXPRESSIVO |
 *   EXCLUIDA |
 *   INATIVA |
 *   NAO_UTILIZADA
 * } ClassificacaoAnalise
 */
const CLASSIFICACAO_ANALISE = {
  PENDENTE_DE_ESCLARECIMENTO: 'PENDENTE_DE_ESCLARECIMENTO',
  EM_ANALISE: 'EM_ANALISE',
  RISCO_DETECTADO: 'RISCO_DETECTADO',
  INEXPRESSIVO: 'INEXPRESSIVO',
  EXCLUIDA: 'EXCLUIDA',
  INATIVA: 'INATIVA',
  NAO_UTILIZADA: 'NAO_UTILIZADA',
};

export default CLASSIFICACAO_ANALISE;
